export class SessionInfo {
  public token: string

  constructor(token: string) {
    this.token = token
  }
}
